import {
	CreateSkuDto,
	SkuStatusEnum,
} from 'models/sku/interfaces/sku.interface';
import { CreateVehicleDetailDto } from 'models/vehicle-detail/interfaces/vehicle-detail.interface';
import * as yup from 'yup';

export const skuDetailsValidationSchema = yup.object({
	brand: yup.string().required('Campo requerido'),
	model: yup.string().required('Campo requerido'),
	cc: yup.number().required('Campo requerido').min(1, 'Cilindraje inválido'),
	year: yup.number().required('Campo requerido').min(2000, 'Año inválido'),
	version: yup.string().optional(),
	generalDescription: yup.string().optional(),
});

export const skuDetailsDefaults: Partial<CreateSkuDto> = {
	brand: undefined,
	model: undefined,
	cc: undefined,
	year: undefined,
	version: undefined,
	generalDescription: undefined,
	status: SkuStatusEnum.ACTIVE,
};

export const specsDefaults: Partial<CreateVehicleDetailDto> = {
	engineType: '',
	maxSpeedKmh: undefined,
	maxPower: '',
	maxTorque: '',
	fuelEfficiencyKml: undefined,
	fuelSystem: '',
	fuelCapacityLiters: undefined,
	transmissionType: '',
	transmissionSpeeds: undefined,
	coolingSystem: '',
	frontSuspension: '',
	rearSuspension: '',
	frontBrakes: '',
	rearBrakes: '',
	frontTire: '',
	rearTire: '',
	dimensions: undefined,
};
